/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_launchpad__account_modal_ideas = /** @type {(inputs: {}) => string} */ () => {
	return `Tanken Sie Ideen: Entdecken Sie unsere Top-Reiseziele und Roadtrips dank`
};

const en_launchpad__account_modal_ideas = /** @type {(inputs: {}) => string} */ () => {
	return `Fill up on ideas: discover our top destinations and road trips thanks to`
};

const es_launchpad__account_modal_ideas = /** @type {(inputs: {}) => string} */ () => {
	return `Llene su maleta de ideas: descubra nuestros destinos estrella y nuestros road trips gracias a`
};

const fr_launchpad__account_modal_ideas = /** @type {(inputs: {}) => string} */ () => {
	return `Faites le plein d’idées : découvrez nos destinations phares et nos road trips grâce à`
};

const it_launchpad__account_modal_ideas = /** @type {(inputs: {}) => string} */ () => {
	return `Fai il pieno di idee: scopri le nostre destinazioni di punta e i nostri road trip grazie a`
};

const nl_launchpad__account_modal_ideas = /** @type {(inputs: {}) => string} */ () => {
	return `Tank vol met ideeën: ontdek onze topbestemmingen en roadtrips dankzij`
};

const pt_launchpad__account_modal_ideas = /** @type {(inputs: {}) => string} */ () => {
	return `Reabasteça suas ideias: descubra nossos destinos imperdíveis e nossos road trips graças a`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_ideas = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.launchpad__account_modal_ideas(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("launchpad__account_modal_ideas", locale)
	if (locale === "de") return de_launchpad__account_modal_ideas(inputs)
	if (locale === "en") return en_launchpad__account_modal_ideas(inputs)
	if (locale === "es") return es_launchpad__account_modal_ideas(inputs)
	if (locale === "fr") return fr_launchpad__account_modal_ideas(inputs)
	if (locale === "it") return it_launchpad__account_modal_ideas(inputs)
	if (locale === "nl") return nl_launchpad__account_modal_ideas(inputs)
	return pt_launchpad__account_modal_ideas(inputs)
};